import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
import { createGlobalStyle } from 'styled-components'
// types
import { IField } from 'types/graphql'
import { InlineFunction as Function } from 'hooks/risks/useRiskNotifications'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// context
import { PublicContext } from 'containers/Risks/Risk/Edit/public'
// graphql
import { EXECUTE_INLINE_FUNCTION, EXECUTE_INLINE_FUNCTION_PUBLIC } from 'graphql/systemProcesses/mutations'
// utils
import { handleError } from 'utils/errors/handlers'

const BUTTON_STYLE = {
  padding: '2px 6px',
  fontSize: '12px'
}

const getColumnStyles = (field?: IField) => createGlobalStyle`
    ${
      field
        ? `.table-column-${field.id}-${field.parentFieldId} {
        width: auto !important;
      }`
        : ''
    }
`

interface Props {
  data: Function
  field?: IField
  riskId?: string
  riskTemplateId?: string
}

const InlineFunction: React.FC<Props> = ({ data, field, riskId, riskTemplateId }) => {
  const router = useRouter()

  const isPublic = React.useContext(PublicContext)

  const [executeFn] = useMutation(isPublic ? EXECUTE_INLINE_FUNCTION_PUBLIC : EXECUTE_INLINE_FUNCTION)

  const [show, setShow] = React.useState(true)
  const [loading, setLoading] = React.useState(false)

  const onFnClick = async () => {
    try {
      setLoading(true)

      await executeFn({
        variables: {
          ...(isPublic && { domain: router.query.domain }),
          input: {
            fieldValueId: data.fieldValueId,
            inlineFunctionId: data.id,
            riskId: riskId || router.query.id,
            riskTemplateId: riskTemplateId || router.query.templateId
          }
        }
      })

      setShow(false)
    } catch (e) {
      handleError(e, 'InlineFunction.onFnClick')
    } finally {
      setLoading(false)
    }
  }

  const GlobalStyles = getColumnStyles(field)

  if (!show) {
    return null
  }

  return (
    <>
      <Button disabled={loading} onClick={onFnClick} style={BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE}>
        {data.name}
      </Button>
      <GlobalStyles />
    </>
  )
}

export default InlineFunction
